import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import LogoOnlyLayout from "../components/dashboard/LogoOnlyLayout";
import DashboardLayout from "../components/layouts";
import RecordNotFound2 from "../components/recordNotFound/SataNitFound.js";
import PaymentRequests from "../pages/paymentsRequests/PaymentRequest.jsx";
import PendingRequests from "../pages/paymentsRequests/PendingRequests.js";
import PendingRequestsPayment from "../pages/paymentsRequests/PendingRequestsDetail.js";
import PaymentRequestsDetails from "../pages/paymentsRequests/PaymentRequestDetails.jsx";
import PaymentThanksPage from "../pages/paymentsRequests/PaymentThanksPage.jsx";
import LoginPage from "../pages/login/LoginPage";
import ForgotPasswordPage from "../pages/forgot-password/ForgotPasswordPage.jsx";
import HomePage from "../pages/home/HomePage.jsx";
import PostJobDetails from "../pages/post/PostJobDetails";
import LiveJobFeeed from "../pages/liveJobFeed/LiveJobFeed";
import Candidates2 from "../pages/jobsCandidate/Candidates.jsx";
import MyJobPost from "../pages/myJobs/MyJobPost.jsx";
import ClientTypes from "../pages/clientTypes/ClientTypes.jsx";
import FavouriteJobs from "../components/jobs/FavouriteJobs.jsx";
import AppliedJobs from "../pages/liveJobFeed/AppliedJob.jsx";
import BlogListCard from "../pages/features/BlogsFeature/BlogListCard.jsx";
import EditProfile from "../pages/profile/Profile.jsx";
import LoginClient from "../pages/login/LoginClient.jsx";
import ClientsList from "../pages/clientTypes/ClientsList.jsx";
import FeatureFlowDecider from "../pages/features/FeatureFlowDecider.jsx";
import BlogDetail from "../pages/features/BlogsFeature/BlogDetail.jsx";
import ReportPage from "../pages/ReportPage/ReportPage.jsx";
import ManageProfile from "../pages/ManageUsers/ManageProfile.jsx";
import Invitations from "../pages/ManageUsers/Invitations.jsx";
import ProfileFlowDecider from "../pages/profile/ProfileFlowDecider.jsx";
import ValidateToken from "../pages/ValidateToken.js";
import ManageAffiliates from "../pages/Clients/components/ManageAffiliates.jsx";
import MyAffiliates from "../pages/Clients/components/MyAffiliates.jsx";
import AffiliateRequest from "../pages/Clients/components/AffiliateRequest.jsx";
import CvManagement from "../pages/CvManagement/CvManagement.jsx";
import JobSettings from "../pages/JobSettings/JobSettings.jsx";
import JobAlerts from "../pages/JobAlerts/JobAlerts.jsx";
import AddOrUpdateAlert from "../pages/JobAlerts/components/AddOrUpdateAlert.jsx";
import RedirectPage from "../pages/RedirectPage.js";
import ChangePassword from "../pages/ChangePassword/ChangePassword.jsx";
import PostJobPage from "../pages/PostJobPage/PostJobPage.jsx";
import RecordNotAvailable from "../pages/RecordNotAvailable/RecordNotAvailable.jsx";
import ClientDetail from "../pages/Clients/ClientDetail.jsx";

const Authentication = () => {
  if (localStorage.getItem("token")) {
    return <Navigate to="/home"> </Navigate>;
  } else {
    return <Navigate to="/login"> </Navigate>;
  }
};

export default function AppRoutes() {
  return (
    <Routes>
      {/* Dashboard routes */}
      <Route element={<DashboardLayout />}>
        <Route path="/" element={<Authentication />} />
        {/* This sets "Home" as the default route */}
        {/* ======================new paths ========================== */}
        <Route path="home" element={<HomePage />} />
        <Route path="my-job-posts" element={<MyJobPost />} />
        <Route path="job-settings" element={<JobSettings />} />
        <Route path="post-new-job" element={<PostJobPage />} />
        <Route path=":source_slug/post-new-job" element={<PostJobPage />} />
        <Route
          path=":source_slug/edit-job/:job_slug"
          element={<PostJobPage />}
        />
        <Route path=":source_slug/home" element={<HomePage />} />
        <Route path=":source_slug/:jobtype_slug" element={<LiveJobFeeed />} />
        <Route path="jobs/:jobtype_slug" element={<LiveJobFeeed />} />
        <Route path=":source_slug/type/:type_slug" element={<ClientsList />} />
        <Route
          path=":source_slug/type/:type_slug/:sector_slug"
          element={<ClientTypes />}
        />
        <Route
          path=":source_slug/type/:type_slug/detail/:client_detail_id"
          element={<ClientDetail />}
        />
        <Route
          path=":source_slug/type/:type_slug/detail/:sector_slug/:client_detail_id"
          element={<ClientDetail />}
        />
        <Route
          path=":source_slug/feature/:feature_slug"
          element={<FeatureFlowDecider />}
        />
        <Route
          path=":source_slug/feature/:feature_slug/:category_slug"
          element={<BlogListCard />}
        />
        <Route
          path=":source_slug/feature/:feature_slug/:category_slug/:blog_type/:blog_slug"
          element={<BlogDetail />}
        />
        <Route
          path=":source_slug/feature/:feature_slug/:blog_type/:blog_slug"
          element={<BlogDetail />}
        />
        <Route path="applied-jobs" element={<AppliedJobs />} />
        <Route path=":source_slug/applied-jobs" element={<AppliedJobs />} />
        <Route
          path=":source_slug/:jobtype_slug/my-job-post"
          element={<MyJobPost />}
        />
        <Route
          path=":source_slug/:jobtype_slug/job-settings"
          element={<JobSettings />}
        />
        <Route
          path=":source_slug/:jobtype_slug/job-alerts"
          element={<JobAlerts />}
        />
        <Route
          path=":source_slug/:jobtype_slug/job-alerts/add-alert"
          element={<AddOrUpdateAlert />}
        />
        <Route
          path=":source_slug/:jobtype_slug/job-alerts/edit-alert/:alert_id"
          element={<AddOrUpdateAlert />}
        />
        <Route path=":source_slug/job/:job_slug" element={<PostJobDetails />} />
        <Route
          path=":source_slug/:jobtype_slug/job/:job_slug"
          element={<PostJobDetails />}
        />
        <Route
          path=":source_slug/:jobtype_slug/my-job-post/job/:job_slug"
          element={<PostJobDetails />}
        />
        <Route
          path=":source_slug/:jobtype_slug/job-candidates-page/:job_id"
          element={<Candidates2 />}
        />{" "}
        <Route
          path=":source_slug/:jobtype_slug/my-job-post/job-candidates-page/:job_id"
          element={<Candidates2 />}
        />{" "}
        <Route
          path=":source_slug/candidates/:job_id"
          element={<Candidates2 />}
        />{" "}
        <Route
          path=":source_slug/:jobtype_slug/job-candidates-page/:job_id/ideal-candidates"
          element={<Candidates2 isOpenInIdealCandidate={true} />}
        />{" "}
        <Route
          path=":source_slug/:jobtype_slug/my-job-post/job-candidates-page/:job_id/ideal-candidates"
          element={<Candidates2 isOpenInIdealCandidate={true} />}
        />{" "}
        <Route
          path=":source_slug/candidates/:job_id/ideal-candidates"
          element={<Candidates2 isOpenInIdealCandidate={true} />}
        />{" "}
        <Route
          path="favourite-jobs/detail/:job_slug"
          element={<PostJobDetails />}
        />
        <Route path="favourite-jobs" element={<FavouriteJobs />} />
        {/* payment Request */}
        <Route path="payment-requests" element={<PaymentRequests />} />
        <Route
          path="payment-requests/:id"
          element={<PendingRequestsPayment />}
        />
        <Route path="payment-done/:id" element={<PaymentThanksPage />} />
        <Route
          path="payment-request-details/:id"
          element={<PaymentRequestsDetails />}
        />
        <Route
          path="payment-requests/pending-request"
          element={<PendingRequests />}
        />
        <Route
          path="payment-requests/accepted-request"
          element={<PendingRequests />}
        />
        {/* end payment Request */}
        <Route path="profile" element={<ProfileFlowDecider />} />
        <Route path="user/:user_id" element={<ProfileFlowDecider />} />
        <Route
          path="user/:feature_slug/:user_id"
          element={<ProfileFlowDecider />}
        />
        <Route path="profile/edit" element={<EditProfile />} />
        <Route path="profile/change-password" element={<ChangePassword />} />
        <Route path="profile/manage-affiliate" element={<ManageAffiliates />} />
        <Route
          path="profile/manage-affiliate/affiliate-received"
          element={<AffiliateRequest />}
        />
        <Route
          path="profile/manage-affiliate/affiliate-sent"
          element={<MyAffiliates />}
        />
        <Route path="manage-users" element={<ManageProfile />} />
        <Route path="invitations" element={<Invitations />} />
        <Route path="cv-management" element={<CvManagement />} />
        <Route path="data-not-available" element={<RecordNotAvailable />} />
        {/* report post and job */}
        {/* <Route path=":home_slug/report/:report_to/:_id" element={<ReportPage />} /> */}
        {/* ================= new paths end ============================*/}
      </Route>

      {/* Auth routes */}
      <Route element={<LogoOnlyLayout />}>
        <Route path="/" element={<Authentication />} />
        <Route path="login" element={<LoginPage />} />
        <Route path="forgot-password" element={<ForgotPasswordPage />} />
        <Route path="*" element={<Authentication />} />
        <Route path="login-client" element={<LoginClient />} />
      </Route>
      <Route
        path="no-access"
        element={<RecordNotFound2 title="Page Not Found" />}
      />
      <Route path="validate-profile" element={<ValidateToken />} />
      <Route path="redirect" element={<RedirectPage />} />
    </Routes>
  );
}
